import { render, staticRenderFns } from "./ChatTemplate.vue?vue&type=template&id=6052c494&scoped=true"
import script from "./ChatTemplate.vue?vue&type=script&lang=js"
export * from "./ChatTemplate.vue?vue&type=script&lang=js"
import style0 from "./ChatTemplate.vue?vue&type=style&index=0&id=6052c494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6052c494",
  null
  
)

export default component.exports